import { ValidateCheckbox, ValidateLabel, ValidateNumber, ValidateRadio, ValidateSearch, ValidateText, ValidateTextarea, ValidateTime, ValidateTimeRange } from "@/util/ValidationUtil.ts";
import { ValidateNested } from "class-validator";
import { Type } from "class-transformer";
import { ChargerCapacitySpec } from "@/dto/inspection/ChargerCapacitySpec.ts";
import { LocationTypeEnum } from "@/enum/LocationTypeEnum.ts";
import { StationDetail } from "@/model/StationDetail.ts";
import { BreakerTypeEnum } from "@/enum/BreakerTypeEnum.ts";
import { StationOpenEnum } from "@/enum/StationOpenEnum.ts";

export class InspectionRapidStationDto {
    inspectionOutlineId: number;
    /**
     * 충전소 이름
     */
    @ValidateSearch("충전소명")
    stationName: string;
    /**
     * 주소
     */
    @ValidateText("충전소 주소")
    stationAddress: string;
    /**
     * 충전소 ID
     */
    @ValidateText("충전소ID")
    stationId: string;
    /**
     * 충전 사업자 - (주)에버온
     */
    @ValidateText("충전 사업자")
    owner: string;
    /**
     * 환경부 충전소 ID
     */
    @ValidateText("환경부 충전소ID")
    kecoStationId: string;
    /**
     * X 좌표
     */
    @ValidateNumber("X좌표")
    gpsX: number;
    /**
     * Y 좌표
     */
    @ValidateNumber("Y좌표")
    gpsY: number;
    /**
     * 상세 위치:옥내 옥외 지상 지하
     */
    @ValidateCheckbox("상세 위치")
    stationLocation: LocationTypeEnum[];
    /**
     * 특이사항
     */
    @ValidateTextarea("특이사항", false, 50)
    detail: string;
    /**
     * 분전함 내 계량기 No.
     */
    @ValidateNumber("분전함 내 계량기 No.")
    meterNumber: string;
    /**
     * 분전함 차단기 No.와 충전기 No. 일치 여부 확인
     */
    @ValidateLabel("분전함 차단기 No.와 충전기 No. 일치 여부 확인")
    isMeterNumberCollect: boolean;
    /**
     * 차단기 타입
     */
    @ValidateRadio("차단기 타입")
    breakerType: BreakerTypeEnum;
    /**
     * 분전함 위치
     */
    @ValidateTextarea("분전함 위치", true, 50)
    distributionLocation: string;
    /**
     * 충전기 총수
     */
    @ValidateNumber("충전기 총수")
    chargerCount: number;
    /**
     * 사용 가능
     */
    @ValidateNumber("사용 가능")
    usableCharger: number;
    /**
     * 사용 중
     */
    @ValidateNumber("사용 중")
    usingCharger: number;
    /**
     * 사용 불가
     */
    @ValidateNumber("사용 불가")
    notUsableCharger: number;
    /**
     * 상태 미확인
     */
    @ValidateNumber("상태 미확인")
    unknownCharger: number;
    /**
     * 전압
     * */
    @ValidateNumber("전압")
    voltage: number;
    /**
     * 충전기 제조사
     * */
    @ValidateText("충전기 제조사")
    maker: string;
    /**
     * 추가 충전기 제조사
     * */
    @ValidateNumber("추가 충전기 제조사", false)
    additionalMaker: string;
    /**
     * 충전기 용량 및 기수 정리
     */
    @ValidateNested({ each: true })
    @Type(() => ChargerCapacitySpec)
    chargerCapacitySpecs: ChargerCapacitySpec[];
    /**
     * 충전기 설치유형 (스탠드형/벽걸이형/이동형/기타)
     */
    @ValidateCheckbox("충전기 설치 유형")
    chargerInstallTypes: string[];
    /**
     /**
     * 이정표 설치
     */
    @ValidateRadio("이정표 설치")
    isGuide: boolean = true;
    /**
     *  전용 주차면 표시
     */
    @ValidateRadio("전용 주차면 표시")
    isOnlyParking: boolean = true;
    /**
     * 완속 급속 표시
     */
    @ValidateRadio("완속/급속 표시")
    isSlowFastDisplay: boolean = true;
    /**
     * 유의사항 안내문 부착 여부
     */
    @ValidateRadio("유의사항 안내문 부착 여부")
    isCaution: boolean = true;
    /**
     * 인지 용이성
     */
    @ValidateRadio("인지 용이성")
    isEasyKnow: boolean = true;
    /**
     * 주차장 출입시 인지
     */
    @ValidateRadio("주차장 출입시 인지")
    isInOutKnow: boolean = true;
    /**
     * 적정공간 확보
     */
    @ValidateRadio("적정공간 확보")
    isSpace: boolean = true;
    /**
     * 쉽게 접근 가능
     */
    @ValidateRadio("쉽게 접근 가능")
    isAccessible: boolean = true;
    /**
     * 충전소 개방여부 (개방/비개방/부분개방)
     */
    @ValidateRadio("개방 여부")
    stationOpen: StationOpenEnum;
    /**
     * 출입 시작 시간
     */
    @ValidateTime("출입 시작 시간")
    stationOpenStartTime: string;
    /**
     * 출입 종료 시간
     */
    @ValidateTime("출입 종료 시간")
    @ValidateTimeRange("stationOpenStartTime", "stationOpenEndTime")
    stationOpenEndTime: string;
    /**
     * 무료 주차
     */
    @ValidateRadio("무료 주차")
    isFreeParking: boolean = true;
    /**
     * 충전시 1시간 무료
     */
    @ValidateRadio("충전시 1시간 무료")
    isDiscountParkingFee: boolean = true;
    /**
     * 주차 요금
     */
    @ValidateNumber("주차 요금")
    parkingFee: number;
    /**
     * 주차 상세 설명
     */
    @ValidateTextarea("주차 상세 설명", false, 50)
    parkingDetail: string;
    /**
     * 주위온도 적정성
     */
    @ValidateRadio("주위 온도 적정성")
    isTemperature: boolean = true;
    /**
     * 미끄럼 방지여부
     */
    @ValidateRadio("미끄럼 방지 여부")
    isNonSlip: boolean = true;
    /**
     * 침수방지 여부
     */
    @ValidateRadio("침수방지 여부")
    isNonFlood: boolean = true;
    /**
     * 분진 가스 안전
     */
    @ValidateRadio("분진/가스 안전")
    isNonDust: boolean = true;
    /**
     * 환기 적정성
     */
    @ValidateRadio("환기 적정성")
    isVentilation: boolean = true;
    /**
     * 진동 발열 안전
     */
    @ValidateRadio("진동/발열 안전")
    isNonShock: boolean = true;
    /**
     * 발열대비 개방성
     */
    @ValidateRadio("발열 대비 개방성")
    isOpen: boolean = true;
    /**
     * 눈 비에 안전
     */
    @ValidateRadio("눈/비에 안전")
    isNonRain: boolean = true;
    /**
     * 빗물 등에 안전
     */
    @ValidateRadio("빗물 등에 안전")
    isSecurityRain: boolean = true;
    /**
     * 사람 접촉에 안전
     */
    @ValidateRadio("사람 접촉에 안전")
    isSecurityTouch: boolean = true;
    /**
     * 위험 표지 여부
     */
    @ValidateRadio("위험 표지 여부")
    isSecurityDisplay: boolean = true;
    /**
     * 분전함 Locking
     */
    @ValidateRadio("분전함 Locking")
    isDistributorLock: boolean = true;
    /**
     * 분전함 접지선
     */
    @ValidateRadio("분전함 접지선")
    isDistributorEarth: boolean = true;
    /**
     * 계량기함 점검 용이
     */
    @ValidateRadio("계량기함 점검 용이")
    isEasyMeter: boolean = true;
    /**
     * 적합케이블 사용
     */
    @ValidateRadio("적합 케이블 사용")
    isCorrectCable: boolean = true;
    /**
     * 금속관 등 금속부분 접지 시설
     */
    @ValidateRadio("금속관 등 금속부분 접지 시설")
    isEarth: boolean = true;
    /**
     * 케이블 손상
     */
    @ValidateRadio("케이블 손상")
    isNonDestroyCable: boolean = true;
    /**
     * 과전류 차단기 정격 P
     */
    @ValidateNumber("P")
    breakerOverP: number;
    /**
     * 과전류 차단기 정격 A
     */
    @ValidateNumber("A")
    breakerOverA: number;
    /**
     * 누전 차단기 정격 P
     */
    @ValidateNumber("P")
    leakageP: number;
    /**
     * 누전 차단기 정격 A
     */
    @ValidateNumber("A")
    leakageA: number;
    /**
     * 감도 전류
     */
    @ValidateNumber("감도 전류")
    sensitiveA: number;
    /**
     * 동작 시간
     */
    @ValidateNumber("동작 시간")
    sensitiveSec: number;
    /**
     * 전선 굵기
     */
    @ValidateNumber("전선 굵기")
    wireWidth: number;
    /**
     * 접지선 굵기
     */
    @ValidateNumber("접지선 굵기")
    earthWidth: number;
    /**
     * 분전반/충전기 외함(2.5㎟ 이상)
     */
    @ValidateRadio("분전반/충전기 외함(2.5㎟ 이상)")
    isNormalCase: boolean = true;
    /**
     * 충전 케이블(0.75㎟ 이상)
     */
    @ValidateRadio("충전 케이블(0.75㎟ 이상)")
    isNormalChargerCable: boolean = true;
    /**
     * 종합의견
     */
    @ValidateTextarea("", false, 1000)
    memo: string;
    /**
     * 충전시설 및 분전함 내부 차단기 정상 동작 여부 확인
     */
    @ValidateRadio("충전시설 및 분전함 내부 차단기 정상 동작 여부 확인")
    isBreaker: boolean = true;
    /**
     * 차단기 비고
     */
    @ValidateTextarea("비고", false, 1000)
    breakerRemarks: string;
    /**
     * 분전함 결선 상태 및 케이블 조임 상태 확인
     */
    @ValidateRadio("분전함 결선 상태 및 케이블 조임 상태 확인")
    isTighten: boolean = true;
    /**
     * 결선/조임 비고
     */
    @ValidateTextarea("비고", false, 1000)
    tightenRemarks: string;
    /**
     * 충전시설 및 분전함 외함 발청,누수(옥외용) 여부를 확인
     */
    @ValidateRadio("충전시설 및 분전함 외함 발청,누수(옥외용) 여부를 확인")
    isNonLeak: boolean = true;
    /**
     * 충전시설 커넥터 균열, 파손, 오염 여부 확인
     */
    @ValidateRadio("충전시설 커넥터 균열,파손,오염 여부 확인")
    isNonConnectorStain: boolean = true;
    /**
     * 변압기 외함 발청, 오일 누유 여부 확인
     */
    @ValidateRadio("변압기 외함 발청, 오일 누유 여부 확인")
    isNonOil: boolean = true;
    /**
     * 충전부 과열에 의한 변색 여부 확인
     */
    @ValidateRadio("충전부 과열에 의한 변색 여부 확인")
    isNonHeat: boolean = true;
    /**
     * 충전소 청소상태,볼라드,스토퍼 등 고정 볼트 조임 확인
     */
    @ValidateRadio("충전소 청소상태,볼라드,스토퍼 등 고정 볼트 조임 확인")
    isStationClean: boolean = true;
    /**
     * 보호잠금장치 정상작동 여부 확인
     */
    @ValidateRadio("보호잠금장치 정상작동 여부 확인")
    isSafetyLock: boolean = true;
    /**
     * 기초패드 및 스탠드폴 등의 파손 등으로 인한 충전시설 고정상태 확인
     */
    @ValidateRadio("기초패드 및 스탠드폴 등의 파손 등으로 인한 충전시설 고정상태 확인")
    isFixed: boolean = true;
    /**
     * 외관 점검 비고
     */
    @ValidateTextarea("비고", false, 1000)
    appearanceRemarks: string;
    /**
     * 급속충전시설은 360V 상하로 38V 이내로 관리
     */
    @ValidateNumber("급속충전시설은 360V 상하로 38V 이내로 관리")
    inputVoltage: number;
    /**
     * 급속충전시설 입력 전압 측정시 R,S,T(3상) 모두 측정해야하며 전압 불평형 발생 여부 확인
     */
    @ValidateRadio("급속충전시설 입력 전압 측정시 R,S,T(3상) 모두 측정해야하며 전압 불평형 발생 여부 확인")
    isPlainVoltage: boolean = true;
    /**
     * 입력 전압 측정 비고란
     */
    @ValidateTextarea("비고", false, 1000)
    voltageRemarks: string;
    /**
     * 전기설비에 대한 전기 안전을 위해 ... 140 및 142.7에 따른다
     */
    @ValidateRadio("전기설비에 대한 전기 안전을 위해 ... 140 및 142.7에 따른다")
    isEarthKec: boolean = true;
    /**
     * 전기설비 검사 및 점검의 방법절차 등에 관한 고시... 접지 저항은 100Ω 이하
     */
    @ValidateNumber("전기설비 검사 및 점검의 방법절차 등에 관한 고시... 접지 저항은 100Ω 이하")
    earthValue: number;
    /**
     * 접지저항 시험 비고
     */
    @ValidateTextarea("비고", false, 1000)
    earthTestRemarks: string;
    /**
     * 급속충전시설은 1MΩ 이상 유지 여부 확인
     */
    @ValidateNumber("급속충전시설은 1MΩ 이상 유지 여부 확인")
    insulation: number;
    /**
     * 절연 저항 시험 비고
     */
    @ValidateTextarea("비고", false, 1000)
    insulationRemarks: string;
    /**
     * 결선 및 상태, 차단기 1,2차 전압 측정, 정상 동작 테스트 여부
     */
    @ValidateRadio("결선 및 상태, 차단기 1,2차 전압 측정, 정상 동작 테스트 여부 확인")
    isElb: boolean = true;
    /**
     * 누전 차단기 비고
     */
    @ValidateTextarea("비고", false, 1000)
    elbRemarks: string;
    /**
     * 전기자동차를 이용하여 충전시설 작동 상태를 점검
     */
    @ValidateRadio("전기자동차를 이용하여 충전시설 작동 상태를 점검")
    isEvTest: boolean = true;
    /**
     * 충전 속도 등 충전 시설 이상 여부 확인
     */
    @ValidateRadio("충전 속도 등 충전 시설 이상 여부 확인")
    isLookTest: boolean = true;
    /**
     * 작동 상태 실차테스트 비고
     */
    @ValidateTextarea("비고", false, 1000)
    evTestRemarks: string;
    /**
     * 비상 정지 버튼의 작동 여부 확인
     */
    @ValidateRadio("비상정지버튼의 작동 여부 확인")
    isEmergencyButtonOk: boolean = true;
    /**
     * 비상정지 비고
     */
    @ValidateTextarea("비고", false, 1000)
    emergencyRemarks: string;
    /**
     * 홈페이지 연동 여부(www.ev.co.kr)
     */
    @ValidateRadio("홈페이지 연동 여부(www.ev.co.kr)")
    isEvHomePage: boolean = true;
    /**
     * 충전 시설 위치
     */
    @ValidateRadio("충전시설 위치")
    isStationLocation: boolean = true;
    /**
     * 상태 정보 확인
     */
    @ValidateRadio("상태정보 확인")
    isStatus: boolean = true;
    /**
     *  적정 조명(기준 조도 40lx)
     */
    @ValidateNumber("적정 조명(기준 조도 40lx)")
    directLight: number;
    /**
     * CCTV(관리원)
     */
    @ValidateRadio("CCTV(관리원)")
    isCctv: boolean = true;
    /**
     * 통행안전(차/보행)
     */
    @ValidateRadio("통행안전(차/보행)")
    isDriveSecurity: boolean = true;
    /**
     * 전용주차면
     */
    @ValidateRadio("전용 주차면(일반차 주차 여부)")
    isOnlyParkingSpace: boolean = true;
    /**
     * 스토퍼 볼라드 설치여부
     */
    @ValidateRadio("스토퍼/볼라드(설치/손상 여부)")
    isStopper: boolean = true;
    /**
     * 터치 스크린 정상 연동
     */
    @ValidateRadio("터치스크린 정상 연동")
    isNormalScreen: boolean = true;
    /**
     * 비상 정지 버튼
     */
    @ValidateRadio("비상 정지 버튼")
    isEmergencyStopButton: boolean = true;
    /**
     * 환경부 카드 사용 가능 여부
     */
    @ValidateRadio("환경부카드 사용가능 여부")
    isUsableEvCard: boolean = true;
    /**
     * 환경부 카드 외 결제 방식
     */
    @ValidateText("환경부 카드 외 결제 방식")
    otherPayMethod: string;
    /**
     * 충전시설/분전함 발청/누수/녹 발생
     */
    @ValidateRadio("충전시설/분전함 발청/누수/녹 발생")
    isNonStain: boolean = true;
    /**
     * 커넥터 균열, 파손
     */
    @ValidateRadio("커넥터 균열/파손")
    isNonDestroyConnector: boolean = true;
    /**
     * 충전기 변색
     */
    @ValidateRadio("충전기 변색")
    isNonColored: boolean = true;
    /**
     * 볼라드/스토퍼 고정
     */
    @ValidateRadio("볼라드/스토퍼 고정")
    isFixedStopper: boolean = true;
    /**
     *  보호잠금장치 정상
     */
    @ValidateRadio("보호잠금장치 정상")
    isSecurityKey: boolean = true;
    /**
     * 충전기 패드 정상 고정
     */
    @ValidateRadio("충전기패드 정상고정")
    isFixedChargerPad: boolean = true;
    /**
     * 소화 설비 비치
     */
    @ValidateRadio("소화 설비 비치")
    isExFire: boolean = true;
    /**
     * 비상시 신속 대피 가능
     */
    @ValidateRadio("비상시 신속 대피 가능")
    isExit: boolean = true;
    /**
     * 스프링 클러의 영향을 받을 우려
     */
    @ValidateRadio("스프링 클러의 영향을 받을 우려")
    isWaterTrouble: boolean = true;
    /**
     * 고장시 비상 연락처
     */
    @ValidateRadio("고장시 비상 연락처")
    isEmergencyCall: boolean = true;
    /**
     * AS센터 연결 가능
     */
    @ValidateRadio("AS센터 연결 가능")
    isConnectAs: boolean = true;
    /**
     * 고장시 표시등
     */
    @ValidateRadio("고장시 표시등")
    isTroubleLight: boolean = true;
    /**
     * 주위 정리정돈
     */
    @ValidateRadio("주위 정리정돈")
    isClean: boolean = true;
    /**
     * 불편민원신고센터 연결 가능
     */
    @ValidateRadio("불편민원신고센터 연결 가능")
    isVoc: boolean = true;
    /**
     * 분전함내 인입 전선 굵기
     */
    @ValidateNumber("분전함 내 인입 전선 굵기")
    inletWire: number;
    /**
     * Main 차단기 용량
     */
    @ValidateNumber("Main 차단기 용량")
    mainBreaker: number;
    /**
     * 부스내 안전 커버 장착
     */
    @ValidateRadio("부스내 안전 커버 장착")
    isSafetyCover: boolean = true;
    /**
     * 누전 차단기 단자대풀림 확인 및 조치
     */
    @ValidateRadio("누전 차단기 단자대풀림 확인 및 조치")
    isLeakageLoose: boolean = true;
    /**
     * 누전 차단기 1,2차 정상 동작 확인/트립 버튼 테스트 등 진행
     */
    @ValidateRadio("누전 차단기 1,2차 정상 동작 확인/트립 버튼 테스트 등 진행")
    isLeakageTest: boolean = true;

    constructor(data?: StationDetail, existingValues?: InspectionRapidStationDto) {
        // 기존 값이 있으면 먼저 복사
        if (existingValues) {
            Object.assign(this, existingValues);
        }
        if (data) {
            this.stationName = data.stationName;
            this.stationAddress = data.stationAddress;
            this.stationId = data.stationId;
            this.owner = data.owner;
            this.kecoStationId = data.kecoStationId;
            this.gpsX = data.gpsX;
            this.gpsY = data.gpsY;
            this.chargerCount = data.chargerCount;
        } else if (!existingValues?.chargerCapacitySpecs || existingValues?.chargerCapacitySpecs.length === 0) {
            this.chargerCapacitySpecs = [new ChargerCapacitySpec()];
        }
    }
}